import { render } from "./WieWirArbeiten.vue?vue&type=template&id=8c14f6bc"
import script from "./WieWirArbeiten.vue?vue&type=script&lang=js"
export * from "./WieWirArbeiten.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__